"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormEditPage = exports.FormEditPageConfig = exports.CSS = void 0;
const theme_1 = require("../components/theme");
const i18n_1 = require("../i18n");
const mithril_1 = require("../mithril");
const form_designer_1 = require("../modules/form.designer/form.designer");
const services_1 = require("../services");
const store_1 = require("../store");
const page_1 = require("./page");
exports.CSS = {
    container: 'c-FormEdit',
};
const Style = {
    [exports.CSS.container]: {
        height: '100%',
        width: '80%',
    },
};
(0, theme_1.addStyles)(Style);
exports.FormEditPageConfig = {
    type: 'internal',
    name: page_1.IkePageName.formEdit,
    path: '/form/edit/:version',
    auth: {
        required: true,
    },
};
class FormEditPage extends page_1.IkePage {
    constructor() {
        super(exports.FormEditPageConfig);
        this.designer = null;
    }
    init() {
        const formVersion = services_1.Services.Route.params.get('version');
        if (!formVersion) {
            services_1.Services.Log.Logger.error('form version not found in route');
            return;
        }
        this.formVersion = formVersion;
        this.designer = new form_designer_1.FormDesigner();
        this.designer.setEditing(true);
        store_1.AppStore.Form.fetch(this.formVersion)
            .then((form) => { var _a; return (_a = this.designer) === null || _a === void 0 ? void 0 : _a.setForm(form); })
            .catch((e) => services_1.Services.Log.Logger.error(e));
    }
    get nodes() {
        if (this.designer == null || !this.formVersion) {
            this.init();
        }
        if (services_1.Services.Department.current == null) {
            services_1.Services.Log.Logger.error('current department is not set');
            return null;
        }
        if (!this.formVersion) {
            services_1.Services.Log.Logger.error('form version is not set');
            return null;
        }
        if (!this.designer) {
            services_1.Services.Log.Logger.error('designer is not set');
            return null;
        }
        if (!services_1.Services.User.current) {
            services_1.Services.Log.Logger.error('no current user');
            return null;
        }
        const userProfile = services_1.Services.UserProfile.get(services_1.Services.User.current.objectId);
        if (userProfile && !services_1.Services.UserProfile.canEditForms(userProfile)) {
            services_1.Services.Log.Logger.error('user cannot edit forms');
            return null;
        }
        if (!store_1.AppStore.Form.exists(this.formVersion)) {
            return (0, mithril_1.m)('div', { className: exports.CSS.container }, (0, i18n_1.Translate)(i18n_1.T.FORM_NOT_FOUND));
        }
        if (this.designer.form == null) {
            return (0, mithril_1.m)('div', { className: exports.CSS.container });
        }
        return (0, mithril_1.m)('div', { className: exports.CSS.container }, this.designer.view());
    }
    onRemove() {
        if (this.designer != null) {
            this.designer.onRemove();
            this.designer = null;
        }
    }
}
exports.FormEditPage = FormEditPage;
//# sourceMappingURL=form.edit.page.js.map